import React, { useMemo, useState } from 'react';
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import PdfFile from '../components/voucher/generator/PdfFile';
import './CheckInOut.css';

const matchesSearch = (item, query) => {
    if (!query) return true;
    const q = query.toLowerCase();
    const guests = item.multipleReg || [];
    const voucherId = item.voucherId != null ? String(item.voucherId).toLowerCase() : '';
    const agent = (item.agentName || '').toLowerCase();
    const airline = (item.airline || '').toLowerCase();
    const guestMatch = guests.some(
        (reg) =>
            (reg.name || '').toLowerCase().includes(q) ||
            (reg.passport || '').toLowerCase().includes(q)
    );
    return voucherId.includes(q) || agent.includes(q) || airline.includes(q) || guestMatch;
};

const guestCount = (rows) =>
    (rows || []).reduce((sum, item) => sum + ((item.multipleReg && item.multipleReg.length) || 0), 0);

export function StayPreview({ pdfFile, onClose }) {
    return (
        <div className="cio-page">
            <div className="cio-preview">
                <div className="cio-preview-bar">
                    <div>
                        <h4>Voucher {pdfFile.voucherId || ''}</h4>
                        <p>{(pdfFile.multipleReg && pdfFile.multipleReg[0] && pdfFile.multipleReg[0].name) || 'Guest record'}</p>
                    </div>
                    <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                        <PDFDownloadLink className="cio-dl" document={<PdfFile data={pdfFile} />} fileName="voucher.pdf">
                            {({ loading }) => (loading ? 'Preparing…' : 'Download voucher')}
                        </PDFDownloadLink>
                        <button type="button" className="cio-ghost" onClick={onClose}>Close preview</button>
                    </div>
                </div>
                <PDFViewer style={{ width: '100%', height: '800px', border: 'none' }}>
                    <PdfFile data={pdfFile} />
                </PDFViewer>
            </div>
        </div>
    );
}

export function StayTable({ rows, dateLabel, dateField, dateKind, hotelField, roomField, onView }) {
    const [search, setSearch] = useState('');
    const filtered = useMemo(
        () => (rows || []).filter((item) => matchesSearch(item, search)),
        [rows, search]
    );

    return (
        <>
            <div className="cio-toolbar">
                <div className="cio-search">
                    <span className="mdi mdi-magnify" />
                    <input
                        type="search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Search guest, passport, agent, or ID"
                    />
                </div>
                <span className="cio-count">{guestCount(filtered)} guest{guestCount(filtered) === 1 ? '' : 's'}</span>
            </div>
            <div className="cio-table-wrap">
                <table className="cio-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Voucher</th>
                            <th>Lead guest</th>
                            <th>Agent</th>
                            <th>Airline</th>
                            <th>{dateLabel}</th>
                            <th>Hotel</th>
                            <th>Room</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {filtered.map((item, index) => {
                            const guests = item.multipleReg || [];
                            const lead = guests[0] || {};
                            return (
                                <tr key={item.voucherId || index}>
                                    <td>{index + 1}</td>
                                    <td>
                                        <div className="cio-guest">{item.voucherId}</div>
                                        <div className="cio-sub">{guests.length} guest{guests.length === 1 ? '' : 's'}</div>
                                    </td>
                                    <td>
                                        <div className="cio-guest">{lead.name || '—'}</div>
                                        <div className="cio-sub">{lead.passport || 'No passport'}</div>
                                    </td>
                                    <td>{item.agentName || '—'}</td>
                                    <td>{item.airline || '—'}</td>
                                    <td className={`cio-date ${dateKind}`}>{item[dateField] || '—'}</td>
                                    <td>{item[hotelField] || '—'}</td>
                                    <td>{item[roomField] || '—'}</td>
                                    <td>
                                        <button type="button" className="cio-icon" title="View" onClick={() => onView(item)}>
                                            <span className="mdi mdi-eye-outline" />
                                        </button>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                {!filtered.length && (
                    <div className="cio-empty">
                        <span className="mdi mdi-account-search-outline" style={{ fontSize: '1.7rem' }} />
                        <h4>No guests in this list</h4>
                        <p>Try another tab or a different search.</p>
                    </div>
                )}
            </div>
        </>
    );
}

export { guestCount };
